import React, { useState } from 'react';

// Components
import Step0WelcomeQuestion from '../../components/WelcomeQuestions/Step0WelcomeQuestion';
import Step1WelcomeQuestion from '../../components/WelcomeQuestions/Step1WelcomeQuestion';
import Step2WelcomeQuestion from '../../components/WelcomeQuestions/Step2WelcomeQuestion';
import Step3WelcomeQuestion from '../../components/WelcomeQuestions/Step3WelcomeQuestion';

// UI kit
import { Card } from '@/components/ui';

const WelcomeQuestionsScreen = () => {

    const [welcomeStep, setWelcomeStep] = useState(0);

    const handleChangeStep = () => {
        if (welcomeStep < 3) {
            setWelcomeStep( welcomeStep + 1 )
        } else {
            return;
        }
    }

    const RenderChildrensComponents = () => {
        switch (welcomeStep) {
            case 0:
                return <Step0WelcomeQuestion handleChange={ handleChangeStep }/>;
            case 1:
                return <Step1WelcomeQuestion handleChange={ handleChangeStep }/>;
            case 2:
                return <Step2WelcomeQuestion handleChange={ handleChangeStep }/>;
            case 3:
                return <Step3WelcomeQuestion handleChange={ handleChangeStep }/>;
            default:
                return null;
        }
    }

    return (
        <div className="flex min-h-screen w-full items-center justify-center bg-background px-4 py-8 sm:py-12">
            <Card className="w-full max-w-[460px] overflow-hidden p-0">
                {/* deck accent bar — thin brand gradient, used sparingly */}
                <div className="h-1 w-full bg-grad" />
                <div className="px-6 py-8 sm:px-8 sm:py-10">
                    { RenderChildrensComponents() }
                </div>
            </Card>
        </div>
    )
}

export default WelcomeQuestionsScreen;
